/**
 * Disable / re-enable a workshop's sales — `POST /workshops/:id/disable` and
 * `POST /workshops/:id/enable`. Both return the refreshed workshop detail.
 */
import { apiFetch } from '../lib/apiFetch';

import type { WorkshopDetail } from './workshops';

export type WorkshopSalesAction = 'disable' | 'enable';

/** A rejected transition, carrying the HTTP status so the UI can say why. */
export class WorkshopSalesError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.name = 'WorkshopSalesError';
    this.status = status;
  }
}

export async function changeWorkshopSales(
  id: string,
  action: WorkshopSalesAction,
): Promise<WorkshopDetail> {
  const res = await apiFetch(`/api/v1/workshops/${id}/${action}`, { method: 'POST' });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { message?: string };
    throw new WorkshopSalesError(res.status, body.message ?? `Request failed: ${res.status}`);
  }
  const body = (await res.json()) as { workshop: WorkshopDetail };
  return body.workshop;
}
